import React from 'react';

/**
 * Reusable SVG search icon.
 * Accepts className to support both header and search-bar use cases.
 */
const SearchIcon = ({ className = '' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="8" />
    <path d="M21 21l-4.35-4.35" />
  </svg>
);

export default SearchIcon;
